import React from 'react';
import ViewBreakdown from './ViewBreakdown';
import EnhancedModal from '@components/generic-modal/EnhancedModal';
import { IPaymentTermsGeneralData } from '../change-payment-terms';

interface IViewBreakdownShellProps {
  open: boolean;
  onClose: () => void;
  generalData: IPaymentTermsGeneralData;
}

const ViewBreakdownShell: React.FC<IViewBreakdownShellProps> = ({
  open,
  onClose,
  generalData,
}) => {
  return (
    <EnhancedModal
      open={open}
      blur={true}
      onClose={onClose}
      title={`Installments Breakdown (${generalData.bill.type === 'production' ? generalData.policy.number : generalData.amendment.number})`}
    >
      <ViewBreakdown billId={generalData.bill.id} />
    </EnhancedModal>
  );
};

export default ViewBreakdownShell;
